import { Box, Flex, Select, Text, Button } from '@chakra-ui/react';
import { borderRadius, color } from '@dozuki/web-js/primitives';
import { useLocalization } from '~/framework';

export type PaginationBarProps = {
   page: number;
   limit: number;
   total: number;
   rowsInPage?: number;
   onPrevious?: () => void;
   onNext?: () => void;
   onChangeLimit?: (limit: number) => void;
   perPageIncrements?: number[];
};

export const PaginationBar = ({
   page,
   limit,
   total,
   onPrevious,
   onNext,
   onChangeLimit,
   rowsInPage,
   perPageIncrements = [10, 20, 50, 100],
}: PaginationBarProps) => {
   const { _js } = useLocalization();

   const numPages = Math.ceil(total / limit);
   const firstResultIndex = (page - 1) * limit;

   const handleChangeLimit = (e: React.ChangeEvent<HTMLSelectElement>) => {
      onChangeLimit && onChangeLimit(parseInt(e.target.value));
   };

   return (
      <>
         <Box h="48px" />
         <Box position="fixed" bottom="0" w="100%" pl={4} pr={4}>
            <Box
               bg="white"
               border="1px solid"
               borderColor={color['gray']['200']}
               borderTopLeftRadius={borderRadius['md']}
               borderTopRightRadius={borderRadius['md']}
               h="48px"
            >
               <Flex align={'center'} justify={'space-between'} h="100%">
                  <Flex align={'center'} gap={2} ml={2}>
                     <Select value={limit} onChange={handleChangeLimit} w="135px">
                        {perPageIncrements.map(increment => (
                           <option key={increment} value={increment}>
                              {_js('%1 per page', increment)}
                           </option>
                        ))}
                     </Select>
                     <Box w="90px">
                        <Text>
                           {`${1 + firstResultIndex}-${
                              firstResultIndex + (rowsInPage ?? limit)
                           } of ${total}`}
                        </Text>
                     </Box>
                  </Flex>
                  <Flex align={'center'} gap={2} mr={2}>
                     <Button isDisabled={page === 1} onClick={onPrevious}>
                        {_js('Previous')}
                     </Button>
                     <Button isDisabled={page === numPages} onClick={onNext}>
                        {_js('Next')}
                     </Button>
                  </Flex>
               </Flex>
            </Box>
         </Box>
      </>
   );
};
